module.exports = __webpack_public_path__ + "img/atom-simple.1e8ada34.svg";